var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("svg-icon", {
    staticClass: "loading-icon",
    class: _vm.iconClass,
    attrs: { name: "loading" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }